(function ($) {
	/**
	 * initializeBlock
	 *
	 * Adds custom JavaScript to the accordion-and-media-block HTML.
	 *
	 * @date    04/05/2024
	 * @since   4.0.0
	 *
	 * @return  void
	 */
	const initializeBlock = function ($block) {
		$block.find('.icon').on('click', function () {
			$block.find('.item').removeClass('active');
			$(this).parent('.item').addClass('active');
		});
	};

	// Initialize each block on a page load (front end).
	$(document).ready(function () {
		$('.wp-block-acf-accordion-and-media-block').each(function () {
			initializeBlock($(this));
		});
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction(
			'render_block_preview/type=accordion-and-media-block',
			function ($block) {
				initializeBlock($($block));
			}
		);
	}
})(jQuery);
